import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import VantageShowcase from "@/components/VantageShowcase";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<VantageShowcase />} />
          <Route path="*" element={<VantageShowcase />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
